import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTFUNNELONBEHALFUSEREMAILITEMBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "placeholder",
  "required"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartFunnelOnBehalfUserEmailItemBlockDescriptor: _generatedCartFunnelOnBehalfUserEmailItemBlockDescriptor,
  cartFunnelOnBehalfUserEmailItemBlockBlocDefinition,
  cartFunnelOnBehalfUserEmailItemBlockDashboardLayout,
  cartFunnelOnBehalfUserEmailItemBlockConfig,
  cartFunnelOnBehalfUserEmailItemBlockResolveConfig,
  cartFunnelOnBehalfUserEmailItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart funnel / On behalf user email input",
    componentType: 'CartFunnelOnBehalfUserEmailItemBlockComponent',
    category: 'cart',
    description: "Cart funnel / On behalf user email input.",
    keywords: [],
    allowedIn: [
      { bloc: "CartFunnelFormBlockComponent", slot: "items" },
    ],
    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-on-behalf-user-email-item.title.label",
        help: "pages.blocks.cart-funnel-on-behalf-user-email-item.title.help",
      }
    }),
    placeholder: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-on-behalf-user-email-item.placeholder.label",
      }
    }),
    required: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.cart-funnel-on-behalf-user-email-item.required.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-funnel-on-behalf-user-email-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-funnel-on-behalf-user-email-item.fieldset.field.label",
            fields: ["title", "placeholder", "required"],
          },
        ],
      },
    ],
  })
);

export function cartFunnelOnBehalfUserEmailItemBlockDescriptor(): IBlockDescriptor;
export function cartFunnelOnBehalfUserEmailItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartFunnelOnBehalfUserEmailItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartFunnelOnBehalfUserEmailItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartFunnelOnBehalfUserEmailItemBlockDescriptor, cartFunnelOnBehalfUserEmailItemBlockProperties, fieldOrder);
}

export {
  cartFunnelOnBehalfUserEmailItemBlockBlocDefinition,
  cartFunnelOnBehalfUserEmailItemBlockDashboardLayout,
  cartFunnelOnBehalfUserEmailItemBlockProperties,
  cartFunnelOnBehalfUserEmailItemBlockConfig,
  cartFunnelOnBehalfUserEmailItemBlockResolveConfig,
};

export type CartFunnelOnBehalfUserEmailItemBlockConfig = typeof cartFunnelOnBehalfUserEmailItemBlockConfig;
